export default __webpack_public_path__ + "static/typography-image-i-972269070aa4ae6f89b37ded123c221922c823ce3705b509b2e5a24a53751d7c.png";